import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "time-chips-container" }
const _hoisted_2 = { class: "chips-grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "chip-content" }
const _hoisted_5 = {
  key: 0,
  class: "chip-date"
}
const _hoisted_6 = {
  key: 1,
  class: "chip-time"
}

import { computed } from 'vue';

interface Props {
  timestamps: number[]
  selectedIndex?: number
  reverse?: boolean,
  useUtc?: boolean,
  dateOnly?: boolean
  hourOnly?: boolean
}

interface Emits {
  (e: 'select', payload: { value: number; index: number }): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeChips',
  props: {
    timestamps: {},
    selectedIndex: { default: -1 },
    reverse: { type: Boolean, default: false },
    useUtc: { type: Boolean, default: false },
    dateOnly: { type: Boolean, default: false },
    hourOnly: { type: Boolean, default: false }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;


const formatDate = (timestamp: number): string => {
  if (props.useUtc) {
    const date = new Date(timestamp);
    timestamp = date.getTime() + date.getTimezoneOffset() * 60*1000; // Adjust for UTC offset
  }
  const date = new Date(timestamp);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric'
  });
};

const formatTime = (timestamp: number): string => {
  if (props.useUtc) {
    const date = new Date(timestamp);
    timestamp = date.getTime() + date.getTimezoneOffset() * 60*1000; // Adjust for UTC offset
  }
  const date = new Date(timestamp);
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};



const timestampsComputed = computed(() => 
  props.reverse ? [...props.timestamps].sort((a,b) => b-a) : [...props.timestamps].sort((a,b) => a-b)
);

const formattedDates = computed(() => 
  timestampsComputed.value.map(timestamp => formatDate(timestamp))
);

const formattedTimes = computed(() => 
  timestampsComputed.value.map(timestamp => formatTime(timestamp))
);
const handleChipClick = (value: number, index: number) => {
  emit('select', { value, index });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timestampsComputed.value, (timestamp, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: timestamp,
          class: _normalizeClass([
          'time-chip',
          { 'active': index === __props.selectedIndex }
        ]),
          onClick: ($event: any) => (handleChipClick(timestamp, index))
        }, [
          _createElementVNode("div", _hoisted_4, [
            (!__props.hourOnly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(formattedDates.value[index]), 1))
              : _createCommentVNode("", true),
            (!__props.dateOnly)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(formattedTimes.value[index]), 1))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})